import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { MetricAnomaly, SCALE_METRICS } from './types';

/** Green when the drift is the good way for the metric, red the bad way, dark for scale metrics (spend, traffic). */
export function trendColor(m: Pick<MetricAnomaly, 'key' | 'higherIsBetter'>, direction: 'up' | 'down'): string {
  if (SCALE_METRICS.has(m.key)) return '#374151';
  return (direction === 'up') === m.higherIsBetter ? '#059669' : '#DC2626';
}

/**
 * The metric's general trend across the window, shown only when it is clear: an arrow and the
 * fitted change over the window. Flat or unreadable trends render nothing, so the table stays quiet.
 */
export default function TrendTag({ m, days }: { m: MetricAnomaly; days: number }) {
  const t = m.trend;
  if (!t || !t.clear || t.direction === 'flat') return null;
  const color = trendColor(m, t.direction);
  const pct = `${t.changeRel >= 0 ? '+' : '−'}${Math.round(Math.abs(t.changeRel) * 100)}%`;
  return (
    <Tooltip title={`General trend over the ${days}-day window: ${t.detail}. The dashed line is the fit.`} arrow>
      <Box component="span" sx={{ color, opacity: 0.6, fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums', cursor: 'help', lineHeight: 1 }}>
        {t.direction === 'up' ? '↗' : '↘'} {pct}
      </Box>
    </Tooltip>
  );
}
